/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// @mui material components
import MenuItem from '@mui/material/MenuItem';
import Icon from '@mui/material/Icon';

// Material Dashboard 2 PRO React components
import MDTypography from 'components/MDTypography';

function UploadExcel({ uploadData, setButton }) {
  const { t } = useTranslation();
  const fileInput = useRef();

  const handleUploadFile = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      uploadData(reader.result, file);

      if (fileInput.current) {
        fileInput.current.value = '';
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <label htmlFor='file-open'>
        <input
          ref={fileInput}
          accept='.xlsx'
          style={{ display: 'none' }}
          type='file'
          onChange={handleUploadFile}
        />
        <MenuItem
          onClick={() => {
            handleClick();
            setButton(null);
          }}
        >
          <MDTypography variant='body2'>
            <Icon color='success'>table_view</Icon>&nbsp;Excel
          </MDTypography>
        </MenuItem>
      </label>
    </div>
  );
}

UploadExcel.propTypes = {
  uploadData: PropTypes.func.isRequired,
  setButton: PropTypes.func.isRequired,
};

export default UploadExcel;
